module.exports = __webpack_public_path__ + "media/images/select2x2-9ec41e9e6287ae95c8ab636908fd1f4d.png";